import React from "react";
import Breadcrumb from "../../utils/Breadcrumb";
import { GetAccess } from "../../utils/RolesandAccess";
import { AddIcon, ExportIcon, ImportIcon, SearchIcon } from "../../assets/icons";
import ToggleViews from "../../utils/ToggleViews";
import Pagination from "../../utils/Pagination";
import { TableLoader } from "../Loader";
import PagenationWithApprove from "../../utils/PagenationWithApprove";
import { Link, useParams } from "react-router-dom";

function ViewTaskTableIndex({
  standardName = "",
  label = "",
  menu = "",
  children,
  total,
  pageIndex,
  setPageIndex = () => {},
  dataCount,
  setDataCount = () => {},
  CreateAccess = "",
  setOpenForm = () => {},
  OverAllPercentage=0,
  isLoading= true,
  header=[],
  ReviewStatus=false,
  ReviewFunction=()=>{},
  SearchData,
  setSearchQuery,
  setShowFilterModal=()=>{},
  isFilter=false,
  clearFilter=()=>{}
}) {
  const {stdId} = useParams()
  return (
    <div className="w-full h-full mx-auto">
      <div className="w-[93%] flex justify-start items-center gap-x-6 pb-1 px-3 mx-auto">
        <Breadcrumb
          items={[
            {
              name: "Standard",
              link:"/main/standard"
            },
            {
              name: standardName,
            },
            {
              name: menu,
            },
            {
              name: label,
            },
          ]}
        />
      </div>
      <div className="w-[96%] mx-auto h-[calc(100vh-105px)] py-2 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-2xl overflow-y-auto">
        <div className=" h-9 flex justify-between items-center w-full px-4">
          <p className="text-xs 2xl:text-sm text-text">
            {label}{" "}

          </p>
          <div className=" flex gap-3 justify-center items-center">
          <Link to={`/standard/${stdId}/information/calendar-management`}>
            {" "}
            <p className=" text-[10px] text-blue-700 bg-gray-100 p-2 rounded shadow-box ">
              Calendar
            </p>
          </Link>
          <form className="flex items-center mx-0" onSubmit={SearchData}>
              <div
                className="w-80 h-[34px] relative rounded-md p-1 flex justify-between items-center"
                style={{ border: "1px solid #EAEBED" }}
              >
                <input
                  type="text"
                  onChange={(e) => setSearchQuery(e)}
                  placeholder="Search Here"
                  className=" w-[90%] text-[13px] px-2 outline-none border-none"
                />
                <button
                  className="p-[5.5px] outline-none border-none  cursor-pointer bg-violet-50  rounded-md flex items-center"
                  type="submit"
                >
                  <SearchIcon/>
                </button>
              </div>
            </form>
            <button
            className="bg-[#7030A0] px-3 py-1 text-sm rounded-md text-white"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
          {isFilter && (
            <button
              className=" px-3 py-1 text-sm rounded-md text-[#7030A0]"
              onClick={clearFilter}
              style={{ border: "1px solid #7030A0" }}
            >
              clear
            </button>
          )}
            <div className=" w-7">
              {GetAccess(CreateAccess) && (
                <span onClick={() => setOpenForm(true)}>
                  <AddIcon />
                </span>
              )}
            </div>
          </div>
        </div>
        <div className=" h-[calc(100vh-194px)] w-full">
        <div className=" w-full h-[calc(100vh-190px)]  relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm ">
                  {header?.map((header) => (
                    <th
                      className={`text-center font-medium px-2  py-4 ${header.width}`}
                    >
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(9)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <>
                {children}    
                </>
              )}
            </table>
          </div>
        </div>
        </div>
        <div className=" h-8 flex justify-between items-center w-full px-4">
            <PagenationWithApprove
            total={total}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            dataCount={dataCount}
            setDataCount={setDataCount}
            OverAllPercentage={OverAllPercentage}
            ReviewFunction={ReviewFunction}
            ReviewStatus={ReviewStatus}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}

export default ViewTaskTableIndex;
